module.exports = __webpack_public_path__ + "static/img/photo_1.2b0a45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_bole/photo_1.jpg
// module id = NDbm
// module chunks = 1